var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.button)?_c('div',{staticClass:"button"},[_c('div',{staticClass:"button-spinner"})]):_c('div',{class:[{ center: _vm.center}]},[_c('div',{staticClass:"spinner",class:[{ small: _vm.small}]},[_vm._v(_vm._s(_vm.message))])])}
var staticRenderFns = []

export { render, staticRenderFns }